import {
    useState,
    type MouseEvent,
} from 'react'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import MoreVertRoundedIcon from '@mui/icons-material/MoreVertRounded'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import ListItemIcon from '@mui/material/ListItemIcon'
import DeleteRoundedIcon from '@mui/icons-material/DeleteRounded'
import Dialog from '@mui/material/Dialog'
import DialogContent from '@mui/material/DialogContent'

import RemoveFeePayerDiscountDialog from './remove-dialog'

function FeePayerDiscountActions({
    feePayerId,
    discountId,
}: {
    feePayerId: number | string,
    discountId: number | string,
}) {

    const [remove, setRemove] = useState<boolean>(false)

    const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
    const open = Boolean(anchorEl)

    const handleClick = (event: MouseEvent<HTMLElement>) => {
        event.stopPropagation()
        setAnchorEl(event.currentTarget)
    }

    const handleClose = () => {
        setAnchorEl(null)
    }

    return (
        <>
            <Tooltip title="Více možností">
                <IconButton
                    id="actions-button"
                    aria-label="actions"
                    aria-controls={open ? 'actions-menu' : undefined}
                    aria-expanded={open ? 'true' : undefined}
                    aria-haspopup="true"
                    color="terciary"
                    onClick={handleClick}
                    sx={{ backgroundColor: 'editableOrange.main' }}
                >
                    <MoreVertRoundedIcon />
                </IconButton>
            </Tooltip>
            <Menu
                id="actions-menu"
                MenuListProps={{
                    'aria-labelledby': 'actions-button',
                }}
                anchorEl={anchorEl}
                open={open}
                onClose={(e: MouseEvent) => {
                    e?.stopPropagation()
                    handleClose()
                }}
                slotProps={{
                    paper: {
                        style: {
                            minWidth: '15ch',
                        }
                    }
                }}
            >
                <MenuItem
                    onClick={e => {
                        e.stopPropagation()
                        setRemove(true)
                        setAnchorEl(null)
                    }}
                >
                    <ListItemIcon>
                        <DeleteRoundedIcon fontSize="small" />
                    </ListItemIcon>
                    Odebrat slevu
                </MenuItem>
            </Menu>
            <Dialog
                open={remove}
                onClose={() => setRemove(false)}
            >
                <DialogContent>
                    <RemoveFeePayerDiscountDialog
                        discountId={discountId}
                        feePayerId={feePayerId}
                        handleClose={() => setRemove(false)}
                    />
                </DialogContent>
            </Dialog>
        </>
    )
}

export default FeePayerDiscountActions
